<template>
  <component
    ref="formInput"
    :class="'formulate-input-label--' + labelSize"
    :is="componentType"
    :type="type"
    v-bind="$attrs"
    :value="value"
    :checked="checked"
    @option:selecting="$emit('option:selecting', $event)"
    @option:selected="$emit('option:selected', $event)"
    @go="$emit('go', $event)"
    @input="$emit('input', $event)"
  >
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
    <template #suffix>
      <slot name="suffix"></slot>
    </template>
  </component>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import CheckboxInput from '@/lego/components/inputs/box/CheckboxInput.vue';
import RadioInput from '@/lego/components/inputs/box/RadioInput.vue';
import TextInput from '@/lego/components/inputs/text/TextInput.vue';
import DateInput from '@/lego/components/inputs/date/DateInput.vue';
import FileInput from '@/lego/components/inputs/file/FileInput.vue';

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    labelSize: {
      type: String,
      default: 'lg',
    },
    value: {
      type: String,
    },
    checked: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const formInput = ref();
    const inputChildren = computed(() => formInput.value?.children);

    return {
      formInput,
      inputChildren,
      componentType: computed(
        () =>
          ({
            checkbox: CheckboxInput,
            radio: RadioInput,
            text: TextInput,
            email: TextInput,
            select: TextInput,
            date: DateInput,
            triotecaSelect: TextInput,
            phone: TextInput,
            file: FileInput,
          }[props.type])
      ),
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &-label {
    @apply style-body-sm m-0 text-neutral-ultradark;

    &--before {
      @apply inline-block;
      .formulate-input-label--lg & {
        @apply style-subtitle-sm-bold mb-xxxs;
      }

      .formulate-input-label--md & {
        @apply style-body-sm mb-xxxs;
      }

      .formulate-input-label--sm & {
        @apply style-overline mb-quark;
      }
    }
  }
  &-link {
    @apply underline outline-none text-neutral-ultradark;
  }

  &-help {
    @apply style-overline text-neutral-medium -mt-quark mb-xxxs;
  }

  &-errors {
    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;
  }
}
.formulate-input::v-deep {
  @apply relative text-neutral-ultradark mb-xs;

  &[data-is-showing-errors='true'] {
    input {
      @apply border-feedback-error-medium border-y-hairline;
    }
  }
}
</style>
